import {createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE = {
  folders: [],
  folderYears: [],
  selectedFolder: {},
};

export const foldersSlice = createSlice({
  name: 'folders',
  initialState: INITIAL_STATE,
  reducers: {
    setFolders: (state, action) => {
      state.folders = action.payload.folders;
    },
    setFolderYears: (state, action) => {
      state.folderYears = action.payload.folderYears;
    },
    setSelectedFolder: (state, action) => {
      state.selectedFolder = action.payload.selectedFolder;
    },
    reset: () => INITIAL_STATE,
  },
});

export const {reset, setFolders, setFolderYears, setSelectedFolder} =
  foldersSlice.actions;
export default foldersSlice.reducer;
